import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Typography, Theme } from '@mui/material';

interface StyleProps {
  panelWidth: number;
  isComponent: boolean;
}

const useStyles = makeStyles<StyleProps>()(
  (theme: Theme, { panelWidth, isComponent }) => ({
    contentContainer: {
      width: `calc(100% - ${panelWidth}px)`,
      padding: isComponent ? 0 : theme.spacing(1),
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      height: '100%',
      overflowY: 'auto',
    },
  })
);

interface CasesContentProps {
  panelWidth: number;
  children?: React.ReactNode;
  /** When true, content is used standalone (e.g., embedded in another app) */
  isStandalone?: boolean;
}

export const CasesContent: React.FC<CasesContentProps> = ({
  panelWidth,
  children,
  isStandalone = false,
}) => {
  // Use isStandalone prop, or fall back to legacy window check for backward compatibility
  const isComponent = isStandalone || !!(window as any).__componentsCallback;
  const { classes } = useStyles({ panelWidth, isComponent });

  return (
    <Box className={classes.contentContainer}>
      {children || (
        <Typography variant="h5" color="primary" align="center">
          To be implemented
        </Typography>
      )}
    </Box>
  );
};
